import { useMutation } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { graphql } from '~/gql'
import { useGraphQLRequest } from '~/hooks/useGraphQLRequest'
import { exists } from '~/utils'

const document = graphql(`
  mutation StrategyMemoListPage_ArchiveStrategyMemo($strategyMemoId: ID!) {
    updateCustomerStrategyMemo(id: $strategyMemoId, status: archived) {
      id
    }
  }
`)

export const useArchiveStrategyMemoMutation = (
  options: MutationOptions<void, string> = {},
) => {
  const { t } = useTranslation()
  const graphQLRequest = useGraphQLRequest()

  return useMutation({
    mutationFn: async (strategyMemoId) => {
      const result = await graphQLRequest({
        document,
        variables: { strategyMemoId },
      })
      const archivedStrategyMemoId = result.updateCustomerStrategyMemo?.id
      if (!exists(archivedStrategyMemoId)) {
        throw new Error(t('archive_failed_3'))
      }
    },
    ...options,
  })
}
